import type { CheckboxGroupProps as AntCheckboxGroupProps } from 'antd/lib/checkbox';
import type { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { Checkbox, Space } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import DoubleInputNumber from '../DoubleInputNumber';
import styles from './index.module.less';

const { Group } = Checkbox;

interface CheckBoxGroupProps extends Omit<AntCheckboxGroupProps, 'onChange' | 'value' | 'options'> {
  options?: Option[];
  onChange?: (values: {value?: CheckboxValueType[], input: any}) => void;
  value?: { value?: CheckBoxGroupProps[], input: any };
  other?: CheckboxValueType;
  unit?: string;
}

interface Option {
  label: ReactNode;
  value: string;
  disabled?: boolean;
}

const CheckBoxGroup: FC<CheckBoxGroupProps> = ({ onChange, value, options = [], other = 'other' }) => {
  const [types, setTypes] = useState<any[] | undefined>([]);
  const [inputDoubleNumberValue, setInputDoubleNumberValue] = useState<any>({});
  const isShowInputDoubleNumber = types?.includes(other);
  const [option, setOption] = useState<any[]>([]);

  useEffect(() => {
    const newOptions = options.map(option => {
      const { value, label, ...restOption } = option;
      if (value === other && isShowInputDoubleNumber) {
        return {
          ...restOption,
          value,
          label: (
            <Space>
              {label}
              <DoubleInputNumber
                unit=''
                onChange={onDoubleInputNumberChange}
                value={inputDoubleNumberValue}/>
            </Space>
          )
        };
      }
      return option;
    });
    setOption(newOptions);
  }, [options, isShowInputDoubleNumber]);

  const onDoubleInputNumberChange = (value: any) => {
    setInputDoubleNumberValue(value);
    onChange?.({ value: types, input: value });

  };

  const onGroupChange = (checkedValues: CheckboxValueType[]) => {
    setTypes(checkedValues);
    if (checkedValues.includes(other as any)) {
      onChange?.({ value: checkedValues, input: inputDoubleNumberValue });
    } else {
      onChange?.({ value: checkedValues, input: undefined });
    }
  };

  useEffect(() => {
    if (!value) {
      return;
    }
    const { value: types, input } = value || {};
    setTypes(types);
    setInputDoubleNumberValue(input);
  }, [value]);

  return (
    <Group
      style={{ flexWrap: 'wrap', display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}
      options={option}
      value={types}
      className={styles.shabiGroup}
      onChange={onGroupChange}/>
  );
};

export default CheckBoxGroup;
